const appendToSearchParams = (searchParams, name, values) => {
	if (!(searchParams instanceof URLSearchParams)) {
		throw new Error('First argument must be an instance of URLSearchParams');
	}

	if (Array.isArray(values)) {
		values.forEach(val => {
			searchParams.append(name, val);
		});
	} else if (values) {
		searchParams.append(name, values);
	}
};

module.exports = appendToSearchParams;